import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import { withExtraArgument } from 'redux-thunk';
import rootReducer from '../reducers';
import { composeWithDevTools } from '@redux-devtools/extension';
import createHelpers from './createHelpers';
import createLogger from './logger';

export default function configureStore(initialState, config) {
  const helpers = createHelpers(config);
  const middleware = [
    withExtraArgument(helpers),
  ];

  let enhancer;

  const isDev = __DEV__ || process.env.NODE_ENV === 'development' || !process.env.NODE_ENV;
  
  if (isDev) {
    // middleware.push(createLogger());
    console.log('🔧 Redux DevTools enabled');
    
    enhancer = composeWithDevTools({
      // Options for Redux DevTools
      name: 'Kabylis App', // Name shown in DevTools
      trace: true, // Enable stack trace
    })(
      applyMiddleware(...middleware)
    );
  } else {
    enhancer = applyMiddleware(...middleware);
  }


  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  const store = createStore(rootReducer, initialState, enhancer);

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (__DEV__ && module.hot) {
    module.hot.accept('../reducers', () =>
      // Don't forget to remove `()` if you change reducers back to normal rootReducer.
      store.replaceReducer(require('../reducers').default()),
    );
  }

  return store;
}
